import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-approve-voilation',
  templateUrl: './approve-voilation.component.html',
  styleUrls: ['./approve-voilation.component.sass']
})
export class ApproveVoilationComponent implements OnInit {
  txtComment: string;
  violation: any;
  approveStatus = '';

  showConfirm: string = 'none';
  displayStyle: string = "{'display':'none'}";
  viewConfirmBox = false;
  mapDiv: L.Map;
  cameracollapsed = true;
  SRcollapsed = true;
  Geocollapsed = true;
  Videocollapsed = true;
  SScollapsed = true;
  IPcollapsed = true;

  secureScreenshotURL: string = "";
  secureScreenVideoURL: string = "";
  secureCamPicURL: string = "";
  secureCamVideoURL: string = "";

  viewViolationDetailsLabel: string = "";
  violationLabel: string = "";
  cameraShotLabel: string = "";
  cameraVideoLabel: string = "";
  screenshotLabel: string = "";
  screenVideoLabel: string = "";
  geoLocationLabel: string = "";
  locationLabel: string = "";
  ipLabel: string = "";
  commentsLabel: string = "";
  typeCommentLabel: string = "";
  approveLabel: string = "";
  rejectLabel: string = "";
  wantToApproveLabel: string = "";
  wantToRejectLabel: string = "";
  closeButton: string = "";

  constructor(private wsService: TrsEventsService, private toastService: ToastrService, private translationService: TranslocoService) {
    this.updateComponentLabels();
  }

  icon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [13, 0],
      iconUrl: 'assets/icons/markers/marker-icon.png',
      shadowUrl: 'assets/icons/markers/marker-shadow.png'
    })
  };

  ngOnInit(): void {
    this.wsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS": this.updateComponentLabels(); break;
        case "SELECTED_VIOLATION": this.handleViolationSelected(response.data); break;
        case "SIGNEDMEDIAURL": this.handleSignedMediaURL(response.data.ScreenShotUrl, response.data.CamPicUrl, response.data.ScreenVideoUrl, response.data.CamVideoUrl); break;
      }
    });
  }

  toggleCameracollapsed() {
    this.cameracollapsed = !this.cameracollapsed;
  }
  toggleSScollapsed() {
    this.SScollapsed = !this.SScollapsed;
  }
  toggleVideocollapsed() {
    this.Videocollapsed = !this.Videocollapsed;
  }
  toggleGeocollapsed() {
    this.Geocollapsed = !this.Geocollapsed;
  }
  toggleIPcollapsed() {
    this.IPcollapsed = !this.IPcollapsed;
  }
  toggleSRcollapsed() {
    this.SRcollapsed = !this.SRcollapsed;
  }
  closeConfirm() {
    this.showConfirm = "none";
  }

  showConfirmModal(statusCode: string) {
    this.approveStatus = statusCode;
    this.showConfirm = "block";
  }
  resetViolationCoordantes() {
    this.violation.Latitude = 0;
    this.violation.Longitude = 0;

  }
  handleViolationSelected = (data: any) => {
    this.txtComment = '';

    if (data != null) {
      this.violation = data;

      this.sendEvent("REFRESHMEDIAURL_REQUEST", {
        "AgentLanId": this.violation.SentBy,
        "EventId": this.violation.EventId,
        "ViolationId": this.violation.ViolationId,
        "supervisorId": this.wsService.supervisorId,
      });
    }
  }

  sendApproveStatusToServer() {
    let data = {
      "agentId": this.violation.AgentLanId,
      "eventId": this.violation.EventId,
      "violationId": this.violation.ViolationId,
      "statusCode": this.approveStatus == 'Approve' ? 1 : 2,
      "comments": this.txtComment
    };
    this.toastService.info("Comments updated successfully!");

    this.sendEvent("SUPERADMIN_APPROVAL", data);
    this.txtComment = "";
    this.violation = null;
    this.closeConfirm();
  }

  sendApproveStatus(approveStatus: string) {
    if (!this.txtComment) {
      this.toastService.warning("Please enter some comments");
      return;
    }
    this.showConfirmModal(approveStatus);
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.wsService.evtdata.next(data);
  }

  handleSignedMediaURL = (screenshotURL: string | null, camPicURL: string | null, screenVideoURL: string | null, camVideoURL: string | null): void => {
    if (screenshotURL != null && screenshotURL !== '' && screenshotURL !== 'NA') {
      this.secureScreenshotURL = screenshotURL;
    }
    else {
      this.secureScreenshotURL = "assets/images/no-data.svg";
    }

    if (camPicURL != null && camPicURL !== '' && camPicURL !== 'NA') {
      this.secureCamPicURL = camPicURL;
    }
    else {
      this.secureCamPicURL = "assets/images/no-data.svg";
    }

    if (screenVideoURL != null && screenVideoURL !== '' && screenVideoURL !== 'NA') {
      this.secureScreenVideoURL = screenVideoURL;
    }
    else {
      this.secureScreenVideoURL = "#";
    }

    if (camVideoURL != null && camVideoURL !== '' && camVideoURL !== 'NA') {
      this.secureCamVideoURL = camVideoURL;
    }
    else {
      this.secureCamVideoURL = "#";
    }
  }

  updateComponentLabels = (): void => {
    this.viewViolationDetailsLabel = this.translationService.translate("Select a violation to view its details here");
    this.violationLabel = this.translationService.translate("Violation");
    this.cameraShotLabel = this.translationService.translate("Camera Shot");
    this.cameraVideoLabel = this.translationService.translate("Camera Video");
    this.screenshotLabel = this.translationService.translate("Screen Shot");
    this.screenVideoLabel = this.translationService.translate("Screen Video");
    this.geoLocationLabel = this.translationService.translate("Geo Location");
    this.locationLabel = this.translationService.translate("Location");
    this.ipLabel = this.translationService.translate("IP");
    this.commentsLabel = this.translationService.translate("Comments");
    this.typeCommentLabel = this.translationService.translate("Type your comment here");
    this.approveLabel = this.translationService.translate("Approve");
    this.rejectLabel = this.translationService.translate("Reject");
    this.wantToApproveLabel = this.translationService.translate("Do you want to Approve?");
    this.wantToRejectLabel = this.translationService.translate("Do you want to Reject?");
    this.closeButton = this.translationService.translate("Close");
  }
}
